var PermissionService_1;
import { __decorate } from "tslib";
import { Injectable } from '@angular/core';
import { UpdatePermissions } from '../state';
import { ConstructorName } from '../decorators';
import * as i0 from "@angular/core";
import * as i1 from "./api.service";
import * as i2 from "@ngxs/store";
import * as i3 from "./monitoring.service";
/**
 * @deprecated all api services from this library are deprecated and will be removed soon. Please access our endpoints via your backend or your own services.
 */
let PermissionService = class PermissionService {
  static {
    PermissionService_1 = this;
  }
  api;
  store;
  monitoringService;
  url = 'geaid/v1/permissions';
  apiVersion;
  constructor(api, store, monitoringService) {
    this.api = api;
    this.store = store;
    this.monitoringService = monitoringService;
    this.monitoringService.sendTrackEvent(Reflect.getMetadata('constructorName', PermissionService_1), 'constructor');
  }
  getPermissionsForStore() {
    this.api.get(this.url).subscribe(result => {
      this.store.dispatch(new UpdatePermissions(result));
    });
  }
  setApiVersion(apiVersion) {
    this.apiVersion = apiVersion ?? this.apiVersion;
    return this;
  }
  setUrl(url) {
    this.url = url ?? this.url;
    return this;
  }
  static ɵfac = function PermissionService_Factory(t) {
    return new (t || PermissionService)(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.Store), i0.ɵɵinject(i3.MonitoringService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PermissionService,
    factory: PermissionService.ɵfac,
    providedIn: 'root'
  });
};
PermissionService = PermissionService_1 = __decorate([ConstructorName('PermissionService')], PermissionService);
export { PermissionService };
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PermissionService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.ApiService
  }, {
    type: i2.Store
  }, {
    type: i3.MonitoringService
  }], null);
})();
